import { Encounter, Reference } from "@curai/js-fhir-tools";
import type * as fhirTypes from "fhir/r4";
import { formatDateTime } from "./time";

interface GenerateChartingSignatureParams {
  practitioner: fhirTypes.Reference;
  participantType: fhirTypes.CodeableConcept;
  timestamp?: string;
}

export const generateChartingSignature = ({
  practitioner,
  participantType,
  timestamp,
}: GenerateChartingSignatureParams) => {
  const practitionerReference = new Reference(practitioner);
  const action = getSignatureAction(participantType);
  const name = practitionerReference.display || "Unknown";

  return `${action} by ${name}${
    timestamp ? ` on ${formatDateTime(timestamp)}` : ""
  }`;
};

export const generateChartingContributions = (
  practitioners: fhirTypes.Reference[],
) => {
  return practitioners.reduce((acc, curr, index) => {
    const name = curr.display;
    if (!index) return `${acc} ${name}`;
    return `${acc}, ${name}`;
  }, "Contributions by");
};

const getSignatureAction = (participantType: fhirTypes.CodeableConcept) => {
  switch (participantType) {
    case Encounter.ParticipantType.ADMITTING:
      return "Created";
    case Encounter.ParticipantType.PRIMARY:
      return "Signed";
    default:
      return "Contributions"; // fail-safe, we generate "Contributions by ____" text using generateChartingContributions() util
  }
};
